import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { HasProduct, ProductContextModel, withProduct } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel, OrderLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    // product: CartLineModel | ProductContextModel | OrderLineModel | ProductModel;
    product: ProductModel;
    extendedStyles?: ProductDetailsDescriptionStyles;
}

type Props = OwnProps;

export interface ProductDetailsDescriptionStyles {
    productDetailLink?: LinkPresentationProps;
    productDetailDescription?: TypographyProps;
    wrapper?: InjectableCss;
}

export const productDetailsDescriptionStyles: ProductDetailsDescriptionStyles = {
    productDetailLink: {
        css: css`
            width: 100%;
        `,
        typographyProps: {
            css: css`
                width: 100%;
                ${wrapInContainerStyles}
            `,
        },
    },
    wrapper: {
        css: css`
            > div[data-test-selector="productDetailsDescription_htmlContent"] {
                -webkit-line-clamp: 2;
                position: relative;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                font-size: 14px;
                > div,
                > a {
                    font-size: 14px;
                    -webkit-line-clamp: 2;
                    position: relative;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                }
                > html {
                    > body {
                        -webkit-line-clamp: 2;
                        position: relative;
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        font-size: 14px;
                        > p,
                        > div,
                        > a {
                            -webkit-line-clamp: 2;
                            position: relative;
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            font-size: 14px;
                        }
                    }
                }
                p {
                    margin-bottom: 0;
                }
                p:not(:first-child) {
                    display: none;
                }
            }
        `,
    },
};

const INTProductDetailsDescription: FC<Props> = ({ product, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(productDetailsDescriptionStyles, extendedStyles));

    // const description = "product" in product ? product.content : "";

    return (
        <StyledWrapper {...styles.wrapper}>
            {product.content?.htmlContent && (
                <div data-test-selector="productDetailsDescription_htmlContent">
                    {parse(product.content.htmlContent, parserOptions)}
                </div>
            )}
        </StyledWrapper>
    );
};

export default INTProductDetailsDescription;
